import React from 'react';
import { ITranslateProps, translate } from '../../mixins/translate';

export interface IRamsWeightedPrioLabelProps extends ITranslateProps {
    value?: string;
}

class RamsWeightedPrioLabelComponent extends React.Component<IRamsWeightedPrioLabelProps, Record<string, unknown>> {
    public override render() {
        if (this.props.value && this.props.value !== '0' && this.props.value !== 'null') {
            return <span className={`label p5 fs11 rams_result${this.props.value}`}> {this.props.t(`ramsPriority.${this.props.value}`)}</span>;
        }
        return <span />;
    }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const RamsWeightedPrioLabel = translate()(RamsWeightedPrioLabelComponent);
